export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', ({ error }) => {
    // TODO: if we find a lot of these, we should consider opening a popup,
    // linear style, with CTA to reload the page
    console.error('caught chunk load error', error)
  })
})
